import React from 'react'
import FlexContainer from 'core-system/FlexContainer'
import SwitchToggle from 'core-system/SwitchToggle'
import Text from 'core-system/Text'

interface ProrationToggleProps {
  active: boolean
  onClick: () => void
  isDisabled?: boolean
  marginTop?: string
}

const ProrationToggle = ({
  active,
  onClick,
  isDisabled = false,
  marginTop,
}: ProrationToggleProps) => (
  <FlexContainer
    alignItems='center'
    justifyContent='space-between'
    marginTop={marginTop}
    marginBottom='1rem'
    style={{ gap: '1rem' }}
  >
    <FlexContainer flexDirection='column' style={{ gap: '0.25rem' }}>
      <Text variant='h5'>Prorate budget</Text>
      <Text variant='body1' color='grey600'>
        Commuters who join mid-cycle receive a budget for the days left in
        that cycle
      </Text>
    </FlexContainer>
    <SwitchToggle active={active} isDisabled={isDisabled} onClick={onClick} />
  </FlexContainer>
)

export default React.memo(ProrationToggle)
